import type { DemoTourStep } from '../types';

export const understandsYouAct: DemoTourStep[] = [
  {
    id: 'aha-understands-context',
    act: '它知道你卡在哪里',
    eyebrow: 'Aha 1',
    route: '/my-agent',
    search: '?panel=inbox',
    highlightSelector: '[data-tour="agent-identity"]',
    position: 'bottom',
    title: '它先接住你的上下文',
    description:
      'Alive 不是等你从头解释任务，而是沿着你的职业背景、节奏和上下文，直接接住今天的工作。',
    voiceover: '真正的理解，不是听见你说了什么。而是知道，你为什么会这样想。',
    visualDirection:
      '镜头停在 Agent 身份区，强调这不是一个临时工具，而是一个已经带着你上下文工作的职业分身。',
  },
  {
    id: 'aha-starts-moving',
    act: '它已经开始替你推进',
    eyebrow: 'Aha 2',
    route: '/my-agent',
    search: '?panel=inbox',
    highlightSelector: '[data-tour="agent-inbox"]',
    position: 'top',
    title: '你还没开口，它已经往前走了一步',
    description:
      '它先整理线索、归拢结论、把零散信息变成可拍板的下一步，让你不再一个人硬扛所有推进。',
    voiceover: '你给它的是经验，它还给你的是行动。',
    visualDirection:
      '重点拍“工作台已经准备好”的感觉，不是通知轰炸，而是安静、可靠、已经铺好路。',
  },
  {
    id: 'aha-learns-judgment',
    act: '它开始像你',
    eyebrow: 'Aha 2.5',
    route: '/my-agent',
    search: '?panel=inbox',
    highlightSelector: '[data-tour="agent-dashboard"]',
    position: 'top',
    title: '它学的不是你的语气，是你的判断',
    description:
      '每一次复盘、纠偏和任务完成，都会沉淀成它更像你的决策方式。职业能力第一次不再每天从零开始。',
    voiceover: '它开始像你。不是学会你的口气，而是学会你的判断。',
    visualDirection:
      '展示成长轨迹、技能和活动面板，让“Agent 在变得更像你”可被看见，但不要游戏化。',
  },
];
